<template lang="pug">
.report-root
    general-title(
        title="网站概况",
        description="帮助您整体了解网站运营情况，提供重点指标趋势图，包括各个时间维度下的相关指标趋势、访客来源、受访等宏观数据。帮助您了解网站的概括性数据。",
        pos="right",
        :date="timeSpan"
    )
        .change-view-mode
            a.hover-link(@click="toMultiMode(false)", :class="{'mode-active': !isMultiMode}") 单站查看
            span.sep |
            a.hover-link(@click="toMultiMode(true)", :class="{'mode-active': isMultiMode}") 多站查看

    div(v-show="!isMultiMode")
        .zone(style="background: transparent;border: 0")
            table.data-table.overview-table(style="table-layout: fixed;")
                thead 
                    tr
                        th(width="100px")
                        th.right 浏览量(PV)
                        th.right 访客数(UV)
                        th.right IP数
                        th.right 新独立访客
                        th.right 跳出率
                        th.right 转化次数
                        th(width="50px")
                tbody
                    tr(
                        v-for="row in surveyDataShown",
                        :style="{fontWeight: row.nameEn === 'today' ? 'bold' : 'normal'}"
                    )
                        td.right {{row.nameCn}}
                          v-tooltip(
                            v-show="row.nameCn == '今天'",
                            :tip="'今日数据按小时汇总，实时数据实时汇总，同时查看这两个数据可能存在差异'",
                            pos="right")
                            i.fa.fa-question-circle(style="margin-left: 5px;")
                        td.right {{row.pv}}
                        td.right {{row.uv}}
                        td.right {{row.ipnum}}
                        td.right {{row.newvst}}
                        td.right {{row.jrate | percent}}
                        td.right {{row.tnum}}
                        td
                    tr(v-if="surveyDataShown.length == 0 && surveyListLoaded")
                        td(colspan="8", style="text-align: center")
                            | 暂无数据
                    tr(v-if="!surveyListLoaded")
                        td(colspan="8", style="text-align: center")
                            img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")

            .btn.btn-toggle-arrow(
                v-show="surveyList.length > 3",
                @click="toggoleSurveyData",
                :class="surveyFullShown ? 'arrow-up' : 'arrow-down'"
            )

        timeSpan(@change="onTimespanChange")

        .zone
            TableTitle(icon="fa fa-signal", title="趋势图")
              IndiceCompare(
                @indiceChange="indiceChange",
                :indicesMenu="indicesMenu", 
                :indice="baseIndice", 
                :compIndice="compareIndice")
                

            LineChart(
                :yAxis="yAxis",
                :legend="flowChartLegend",
                :xAxis="flowChartXAxis",
                :series="flowChartSeries",
            )

        .zone.top-zone
            .top-zone-row
                .top-zone-cell
                    div.mr6
                        TableTitle(icon="fa fa-link", title="来源网站Top10")
                            a.btn.btn-icon.pull-right(@click="goToSiteOrigin('origin')")
                                i.fa.fa-eye
                                | 查看全部
                        table.opt-table
                            thead
                                tr
                                    th(width="56px")
                                    th 来源
                                    th.right 浏览量(PV)
                                    th.right 占比
                            tbody
                                tr(v-for="item,index in topSources")
                                    td(width="56px")
                                      p.rank(:class="`rank_${index+1}`") {{index+1}}
                                    td 
                                        a(
                                            v-if="item.refdomain !== '-'",
                                            :href="item.refdomain | httpUrl",
                                            :title="item.refdomain",
                                            target="_blank"
                                        )
                                            | {{item.refdomain}}
                                        span(v-if="item.refdomain === '-'") {{item.refdomain}}
                                    td.right {{item.pv}}
                                    td.right {{item.rate | percent}}

                .top-zone-cell
                    div.ml6
                        TableTitle(icon="fa fa-ellipsis-h", title="搜索词Top10")
                            a.btn.btn-icon.pull-right(@click="goTo('keyword')")
                                i.fa.fa-eye
                                | 查看全部
                        table.opt-table
                            thead
                                tr
                                    th(width="56px")
                                    th 搜索词
                                    th.right 浏览量(PV)
                                    th.right 占比
                            tbody
                                tr(v-for="item,index in topKeywords")
                                    td(width="56px")
                                      p.rank(:class="`rank_${index+1}`") {{index+1}}
                                    td {{item.keyword}}
                                    td.right {{item.pv}}
                                    td.right {{item.rate | percent}}
            .top-zone-row
                .top-zone-cell
                    div.mr6
                        TableTitle(icon="fa fa-search", title="搜索引擎Top5")
                            a.btn.btn-icon.pull-right(@click="goToSEOrigin")
                                i.fa.fa-eye
                                | 查看全部
                        table.data-table.qhbar-table
                            thead
                                tr
                                    th(style="text-align: right;") 浏览量(PV)及占比
                                    th.fff-divider 搜索引擎
                            tbody
                                tr(v-for="item in topSearchEngines")
                                    td.pad-0
                                        div.percent-bar-con
                                            .percent-bar(
                                                :style="{width: item.width + 'px'}",
                                                :class="{'percent-bar-yellow' : item.width}"
                                            )
                                                | {{item.pv}}({{item.rate | percent}})
                                    td.fff-divider
                                        a(
                                            v-if="item.refdomain !== '-'",
                                            :href="item.refdomain | httpUrl",
                                            :title="item.refdomain",
                                            target="_blank"
                                        )
                                            | {{item.refdomain}}
                                        span(v-if="item.refdomain === '-'") {{item.refdomain}}
                .top-zone-cell
                    div.ml6
                        TableTitle(icon="fa fa-bookmark", title="受访页面Top5")
                            a.btn.btn-icon.pull-right(@click="goTo('page')")
                                i.fa.fa-eye
                                | 查看全部
                        table.data-table.qhbar-table
                            thead
                                tr
                                    th(style="text-align: right;") 浏览量(PV)及占比
                                    th.fff-divider 受访页面
                            tbody
                                tr(v-for="item in topVisitedPages")
                                    td.pad-0
                                        div.percent-bar-con
                                            .percent-bar(
                                                :style="{width: item.width + 'px'}",
                                                :class="{'percent-bar-green' : item.width}"
                                            )
                                                | {{item.pv}}({{item.rate | percent}})
                                    td.fff-divider
                                        a(
                                            v-if="item.onurl !== '-'",
                                            :href="item.onurl | httpUrl",
                                            :title="item.onurl",
                                            target="_blank"
                                        )
                                            | {{item.onurl}}
                                        span(v-if="item.onurl === '-'") {{item.onurl}}
                
        
            .top-zone-row
                .top-zone-cell(width="33.33333%")
                    div.mr6
                        TableTitle(icon="fa fa-user", title="性别比例")
                            a.btn.btn-icon.pull-right(@click="goTo('attributes')")
                                i.fa.fa-eye
                                | 查看全部
                        PieChart(
                            :legend="genderLegend",
                            :series="genderSeries",
                            :option="pieConf",
                            :color="genderPieColors"
                        )
                .top-zone-cell(width="33.33333%")
                    div.mr6
                        TableTitle(icon="fa fa-leaf", title="年龄分布")
                            a.btn.btn-icon.pull-right(@click="goTo('attributes')")
                                i.fa.fa-eye
                                | 查看全部
                        PieChart(
                            :legend="ageLegend",
                            :series="ageSeries",
                            :option="pieConf"
                        )
                .top-zone-cell(width="33.33333%")
                    div
                        TableTitle(icon="fa fa-map-marker", title="访客地域")
                            a.btn.btn-icon.pull-right(@click="goTo('geodistrib')")
                                i.fa.fa-eye
                                | 查看全部
                        MapChart(
                            name="PV",
                            :series="provSeries"
                        )

   
   
    .multi-sites-view(v-show="isMultiMode")
        .site-survey(v-for="item in domainListSurvey", :key="item.domain")
            h2
                a(:href="item.domain.domain | httpUrl", :title="item.domain.domain") {{item.domain.domain | ellipsis(80)}}
                a.hover-link.pull-right(@click="checkReport(item.domain)") 查看报告
            table.data-table(style="table-layout: fixed; margin: 0")
                thead 
                    tr
                        th
                        th 浏览量(PV)
                        th 访客数(UV)
                        th IP数
                        th 新独立访客
                        th 跳出率
                        th 转化次数
                tbody
                    tr(
                        v-for="row in item.data",
                        :style="{fontWeight: row.nameEn === 'today' ? 'bold' : 'normal'}"
                    )
                        td.tac-r {{row.nameCn}}
                        td {{row.pv}}
                        td {{row.uv}}
                        td {{row.ipnum}}
                        td {{row.newvst}}
                        td {{row.jrate | percent}}
                        td {{row.tnum}}
                    tr(v-show="!item.data || !item.data.length")
                        td(colspan="7", style="text-align: center; background: #fff") 暂无数据
        div(style="text-align: center", v-show="!multiListLoaded")
            img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
</template>

<script>
/* global _ */
import { provSimplify, getDatesByRange, getDateString, getDateHours } from '../../script/util.js'
import Mixin from '../mixin.js'
import {USER_ATTR_MAP, INDICE_DEFAULT} from './constants.js'

const AGE_STAGES = USER_ATTR_MAP.age

const placeholder = (keys, text = '-') => {
  return keys.reduce((accu, key) => {
    accu[key] = text
    return accu
  }, {})
}
const fillArray = (arr, len, obj) => {
  const length = len - arr.length
  if (length <= 0) {
    return arr.slice(0, len)
  };

  const pls = Array.from({ length }).fill(_.clone(obj))
  return arr.concat(pls)
}
const placeholderify = (data, keys = [], len = 10) => {
  data = data || []
  return fillArray(data, len, placeholder(keys))
}

const EMPTY_ITEM = {
  domainId: 0,
  pv: 0, // 浏览量
  uv: 0, // 访客数
  ipnum: 0, // ip数
  newvst: 0, // 新独立访客
  jrate: 0, // 跳出率
  atime: 0, // 平均时常
  anum: 0, // 平均访问页数
  vnum: 0, // 访问次数
  tnum: 0, // 转化次数 
  trate: 0 // 转化率
}

export default {
  data () {
    const indices = INDICE_DEFAULT

    const today = getDateString(new Date())

    return {
      isMultiMode: false,
      timeSpan: {
        start: today,
        end: today
      },
      indicesMenu: indices.map(arr => { return {label: arr[1], value: arr[0]} }),
      baseIndice: indices[1][0],
      compareIndice: indices[0][0],
      flowData: [],
      surveyList: [],
      surveyListLoaded: false,
      surveyFullShown: false,
      topSources: placeholderify(null, ['refdomain', 'pv', 'rate']),
      topKeywords: placeholderify(null, ['keyword', 'pv', 'rate']),
      topSearchEngines: placeholderify(null, ['refdomain', 'pv', 'rate']),
      topVisitedPages: placeholderify(null, ['onurl', 'pv', 'rate']),
      yAxis: [],
      genderData: null,
      genderLegend: ['男性', '女性'],
      genderPieColors: ['#6390a6', '#e5675c'],
      ageData: null,
      provData: null,
      domainListSurvey: [],
      multiListLoaded: false
    }
  },
  mixins: [Mixin],
  computed: {
    domainId () {
      return this.$store.state.domainId
    },
    domainList () {
      return this.$store.state.domainList
    },
    surveyDataShown () {
      const shownLen = this.surveyFullShown ? 6 : 3
      return this.surveyList.slice(0, shownLen)
    },
    getTypeName () {
      return {
        baseType: this.baseIndice,
        baseName: _.find(this.indicesMenu, {value: this.baseIndice}).label,
        compareType: this.compareIndice !== '_' ? this.compareIndice : '',
        compareName: _.find(this.indicesMenu, {value: this.compareIndice}).label
      }
    },
    flowChartLegend () {
      const {baseType, baseName, compareType, compareName} = this.getTypeName

      const arr = [
        baseType && baseName,
        compareType && compareName
      ].filter(a => Boolean(a))
      return _.uniqWith(arr, _.isEqual)
    },
    flowChartSeries () {
      const {baseType, baseName, compareType, compareName} = this.getTypeName

      let series = [
        {
          name: baseName,
          _type: baseType,
          data: []
        }, {
          name: compareName,
          yAxisIndex: 1,
          _type: compareType,
          data: []
        }
      ].filter(item => Boolean(item._type))
      series = _.uniqWith(series, _.isEqual)

      this.flowData.forEach(item => {
        series.forEach(s => {
          s.data.push(item[s._type])
        })
      })
      return series
    },
    flowChartXAxis () {
      return this.flowData.map(i => i.date)
    },

    genderSeries () {
      if (!this.genderData) return []

      const male = this.genderData[1]
      const female = this.genderData[2]
      const ret = [
        /* eslint-disable no-mixed-operators */
        { name: '男性', value: Number(male && male.rate || 0) },
        { name: '女性', value: Number(female && female.rate || 0) }
      ]
      if (ret[0].value === 0 && ret[1].value === 0) {
        return []
      }
      return ret
    },
    ageSeries () {
      const data = this.ageData
      if (!data) return []

      return data.map(item => {
        const {age, rate} = item
        return {
          name: AGE_STAGES[age],
          value: Number(rate) || 0
        }
      })
    },
    ageLegend () {
      return this.ageSeries.map(i => i.name)
    },
    provSeries () {
      const data = this.provData
      if (!data) return []

      return data.map((prov) => {
        return {
          name: provSimplify(prov.province),
          value: Number(prov.pv)
        }
      })
    },

    pieConf () {
      return {
        legend: { show: true },
        tooltipFormatter: '{b}:{d}%',
        labelFormatter: '{b}'
      }
    }
  },

  watch: {
    domainId () {
      this.getSurveyData()
      this.getFlowData()
      this.getTopData()
    }
  },
  mounted () {
    if (_.has(this.$route.query, 'infoshow') && this.$route.query.infoshow === 1) {
      this.$Modal.confirm('该账号未完善用户信息，现在去完善？', result => {
        if (result) {
          this.$router.push('/nopermission')
        }
      })
    }
  },
  methods: {
    indiceChange (obj) {
      this.baseIndice = obj.customIndice
      this.compareIndice = obj.twoIndice
      const yAxis = []
      yAxis.push(this.putyAxisItem(this.baseIndice))
      if (!(this.compareIndice === '_' || this.compareIndice === '')) {
        let newItem = this.putyAxisItem(this.compareIndice)
        newItem.splitLine = {
          show: false
        }
        yAxis.push(newItem)
      }
      this.yAxis = yAxis
    },
    goTo (path) {
      // this.$store.commit('SET_DATE_PARAM', _.clone(this.timeSpan))
      this.$router.push(path)
    },
    goToSiteOrigin () {
      this.$store.commit('SET_CROSS_PARAM', {
        webOriginTab: 'refdomain',
        webOriginView: 'all'
      })
      this.goTo('origin')
    },
    goToSEOrigin () {
      this.$store.commit('SET_CROSS_PARAM', {
        webOriginView: 'searchEngine',
        webOriginTab: ''
      })
      this.goTo('origin')
    },
    // 切换时间
    // timeSpan 组件初始化时就会触发该事件
    onTimespanChange ({ start, end }) {
      this.timeSpan = { start, end }
      // 同步时间
      // this.$store.commit('SET_DATE_PARAM', _.clone(this.timeSpan))
      this.getFlowData()
      this.getTopData()
    },

    // 切换对比指标
    onIndiceChange () {
      this.getFlowData()
    },

    toggoleSurveyData () {
      this.surveyFullShown = !this.surveyFullShown
    },

    toMultiMode (isMulti) {
      // 未变
      if (this.isMultiMode === isMulti) {
        return
      }

      this.isMultiMode = isMulti
      if (isMulti) {
        this.multiListLoaded = false
        this.getDomainListSurvey().then(() => {
          this.multiListLoaded = true
        })
      }
    },

    checkReport (domain) {
      this.toMultiMode(false)
      this.$store.commit('SET_DOMAINID', { domainId: domain.id })
      this.$store.commit('SET_CURRENT_DOMAIN', { domain })

      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },

    getFlowData () {
      if (!this.domainId) return

      const { start, end } = this.timeSpan
      const cycle = start === end ? 'hour' : 'day'
      const params = {
        start,
        end,
        cycle,
        domainId: this.domainId,
        ps: 9999
      }

      this.$store.dispatch('SET_CHART_LOADING', true)
      this.$http.get('/api/report/flow', {
        params
      }).then(res => {
        return res.data
      }).then(({ errno, errmsg, list, total }) => {
        const { start, end } = this.timeSpan
        const cycle = start === end ? 'hour' : 'day'
        if (cycle === 'day' && list && list.length) {
          list.forEach(i => {
            [i.date] = i.date.split(' ')
          })
          list = getDatesByRange(this.timeSpan).map(date => {
            return _.find(list, { date }) || _.extend({ date }, EMPTY_ITEM)
          })
        } else if (cycle === 'hour' && list && list.length) {
          list = getDateHours(start).map(date => {
            return _.find(list, { date }) || _.extend({ date }, EMPTY_ITEM)
          })
        }
        this.flowData = list
        this.$store.dispatch('SET_CHART_LOADING', false)
      })
    },

    getTopData () {
      if (!this.domainId) return

      const { start, end } = this.timeSpan

      this.$http.get('/api/report/top', {
        params: {
          domainId: this.domainId,
          start,
          end
        }
      }).then(res => {
        return res.data
      }).then(({ errno, errmsg, data }) => {
        if (errno > 0) return this.$Modal.warn(errmsg)
        // 来源网站Top10
        this.topSources = placeholderify(
          data.refdomain,
          ['refdomain', 'pv', 'rate']
        )
        // 搜索词Top10
        this.topKeywords = placeholderify(
          data.keyword,
          ['keyword', 'pv', 'rate']
        )

        const calWidth = (data) => {
          if (!data.length) return data

          data = data.sort((a, b) => b.pv - a.pv)
          const max = data[0].pv
          return data.map(item => {
            item.width = Math.round(item.pv * 100 / max) + 80
            return item
          })
        }
        // 搜索引擎Top5
        this.topSearchEngines = placeholderify(
          calWidth(data.se), ['refdomain', 'pv', 'rate'], 5
        )
        // 受访页面Top5
        this.topVisitedPages = placeholderify(
          calWidth(data.onurl), ['onurl', 'pv', 'rate'], 5
        )

        // 性别
        this.genderData = data.gender
        // 年龄
        this.ageData = data.age.sort((a, b) => b.age - a.age)
        // 地域
        this.provData = data.province
      })
    },

    // 网站概况头部数据
    getSurveyData () {
      this.surveyListLoaded = false
      this.getDomainSurvey(this.domainId).then((list) => {
        this.surveyList = list
        this.surveyListLoaded = true
      })
    },

    // 多站查看
    getDomainListSurvey () {
      const list = this.domainList
      const len = list.length

      if (!len) {
        return
      }

      const request = domain => {
        return this.getDomainSurvey(domain.id)
          .then((data) => {
            return {
              domain: domain,
              data
            }
          })
      }

      const surveyList = this.domainListSurvey
      let promise = Promise.resolve()
      const packRequest = (index) => {
        promise = promise.then(() => {
          const proms = list.slice(index, index + 5).map(request)
          return Promise.all(proms).then(data => {
            surveyList.push.apply(surveyList, data)
          })
        })
      }

      // 清空数组
      this.domainListSurvey.splice(0, this.domainListSurvey.length)
      let index = 0
      while (index < len) {
        packRequest(index)
        index += 5
      };

      return promise
    },

    getDomainSurvey (domainId) {
      if (!domainId) return Promise.resolve([])

      const wordMap = {
        today: '今天',
        yesterday: '昨天',
        expected: '今天预计',
        yestertime: '昨天此时',
        a90: '近90天平均',
        highest: '历史峰值'
      }

      return this.$http.get('/api/report/survey', {
        params: { domainId }
      }).then(res => {
        return res.data
      }).then(({ errno, errmsg, data }) => {
        return Object.keys(data || []).map(key => {
          const item = data[key]
          item.nameEn = key
          item.nameCn = wordMap[key]
          return item
        })
      }).catch(e => {
        return []
      })
    }
  },
  created () {
    this.getSurveyData()
    this.getFlowData()
    this.getTopData()
  }
}
</script>

<style scoped>
@import '../../css/base/variables.css';

.change-view-mode {
    float: right;
    font-size: 12px;
    color: #666;
    font-weight: normal;

    & > .sep {
        display: inline-block;
        width: 2em;
        color: #a1a1a1;
        text-align: center;
    }
}

.hover-link {
    font-size: 12px;
    color: #a1a1a1;
    text-decoration: none;
    height: 28px;
    line-height: 28px;
    font-weight: normal;
}
.hover-link:hover {
    color: #384b66;
    text-decoration: underline;
}

.data-table {
    table-layout: fixed;
}

.data-table th:first-child,
.data-table td:first-child {
    padding-left: 20px;
}
.data-table .tac-r {
    text-align: right;
}
.opt-table .rank {
  width: 16px;
  line-height: 16px;
  background: var(--Slightgrey);
  color: var(--white-color);
  margin: 0;
  text-align: center;
}
.opt-table .rank_1 {
  background: var(--Red);
}

.opt-table .rank_2 {
  background: var(--Amber);
}
.opt-table .rank_3 {
  background: var(--Yellow);
}

.top-zone,
.zone {
    background: #fff;
    overflow: hidden;
    margin-bottom: 20px;
}
.zone header {
    padding-right: 1em;
}
.top-zone {
    border: 0;
    background: transparent;
}
.top-zone-row {
    display: table;
    table-layout: fixed;
    width: 100%;
}
.top-zone-cell {
    display: table-cell;

    & > div {
        background: #fff;
        border: 1px solid #e5e5e5;
        margin-bottom: 20px;
    }
}

.multi-indices-menu {
  float: right;
  font-size: 14px;
}
.multi-indices-menu select {
  width: 9em;
  margin: 0 5px;
}
.compare-indice {
  color: #999;
  font-size: 12px;
  margin: 0 5px;
}

.qhbar-table {
    & > tbody tr:nth-child(even) {
        background: #fff;
    }
    
}

.percent-bar-con {
    width: 100%;
    overflow: hidden;
    background: #f5f8fb;
}
.percent-bar {
    float: right;
    padding-right: 10px;
    line-height: 1.4;
    text-align: right;
}
.percent-bar-yellow {
    color: #fff;
    background: #e8b71a;
}
.percent-bar-green {
    color: #fff;
    background: #4fc188;
}

.view-all {
    float: right;
    font-size: 12px;
    color: #B0B3B7;

    & a {
        margin-left: 5px;
        text-decoration: none;
    }
    &:hover a {
        text-decoration: underline;
    }
}

.ml6 {
    margin-left: 6px;
}
.mr6 {
    margin-right: 6px;
}
.bdb {
    border-bottom: 1px solid #e5e5e5;
}
.btn-icon {
    margin-top: 14px;
}
.btn-toggle-arrow {
    display: block;
    position: relative;
    width: 48px;
    height: 10px;
    padding: 0;
    line-height: 1;
    vertical-align: middle;
    border-radius: 0;
    margin: 0 auto;
    background: #c8ccd5;
    color: #fff;

    &:hover{
        color: #fff;
        background-color: var(--Green);
    }    
}
.arrow-up:after, .arrow-down:after{
    content: '';
    display: block;
    position: absolute;
    left: 18px;
    width: 0;
    height: 0;
    bottom: 3px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
}
.arrow-up:after{
    border-bottom: 4px solid #fff;
}
.arrow-down:after{
    border-top: 4px solid #fff;
}
.arrow-up:after, .arrow-down:after {
    content: '';
    display: block;
    position: absolute;
    left: 18px;
    bottom: 3px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
}
.arrow-down:after {
    border-top: 4px solid #fff;
}
.arrow-up:after {
    border-bottom: 4px solid #fff;
}
.site-survey {
    margin-bottom: 20px;
}
.site-survey h2 {
    padding: 0;
    margin-top: 20px;
    margin-bottom: 10px;
}
.mode-active {
    font-weight: bold;
    text-decoration: underline;
    color: #384b66
}
.data-table td.pad-0 {
    padding-left: 0;
    padding-right: 0;
}

.fff-divider {
    position: relative;
    padding-left: 20px;
}
.fff-divider:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #fff
}
.qhbar-table td,
.qhbar-table th {
  padding: 0 20px;
}
.qhbar-table th:first-child {
  padding: 0 17px;
}

.overview-table td:first-child {
  border-left: 1px solid #e5e5e5;
}
.overview-table td:last-child {
  border-right: 2px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// overview.vue?4b55ad89